import { type ChemistryControllerHost } from '@adornis/chemistry/controllers/chemistry-controller.js';
import type { ApexOptions } from 'apexcharts';

export const getApexLineChartOptions = (
  host: ChemistryControllerHost,
  values: number[],
  labels: string[],
  dataPointName: string,
) => {
  const options: ApexOptions = {
    series: [{ data: values, name: dataPointName }],
    chart: {
      height: 350,
      toolbar: { show: false },
      type: 'line',
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      colors: [host.colors.accent.string],
    },
    xaxis: {
      categories: labels,
    },
    legend: { position: 'top', horizontalAlign: 'right' },
  };
  return options;
};

export const getApexStackedBarChartOptions = (
  host: ChemistryControllerHost,
  values: Array<{ name: string; data: number[]; color?: string }>,
  labels: string[],
) => {
  const options: ApexOptions = {
    series: values,
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: '13px',
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    xaxis: {
      categories: labels,
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
    },
  };
  return options;
};
